type Language = {
  nativeName: string;
};

const languages: Record<string, Language> = {
  en: {
    nativeName: 'English',
  },
  es: {
    nativeName: 'Español',
  },
  ptbr: {
    nativeName: 'Português Brasileiro',
  },
};

type LanguageOption = {
  value: string;
  label: string;
};

export const getAllLanguages = (): LanguageOption[] => {
  return Object.entries(languages).map(([key, language]) => ({
    value: key,
    label: language.nativeName,
  }));
};

export const getLanguageByKey = (key: string): LanguageOption | undefined => {
  const language = languages[key];
  return language ? { value: key, label: language.nativeName } : undefined;
};

export default languages;
